var exports = {
  "iE": "xe533113f--1ac396--wrapper",
  "x6": "xe533113f--1ac396--button",
};

module.exports = exports;
